<div class="footer-group-wrapper py-4">
  <span class="discard-btn btn flex flex-1 justify-center p-1 pointer-cursor" (click)="onDiscard()">Discard</span>
  <span class="send-btn btn flex flex-1 justify-center p-1 pointer-cursor" (click)="onSave()">Send</span>
</div>
